import React, { useEffect, memo, useRef } from 'react'

//Components.
import ChallengeCoverCard from '../../card-component/challenge-card-component/ChallengeCoverCard';

//Dependencies.
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { motion } from 'framer-motion';

//Functions.
  //Slice.
  import { allActiveChallenges, FStransferChallenge } from '../../../slices/challengesSlice'
  import { loggedInUser } from '../../../slices/allUsersSlice';
  import { updateFSvideoData, videosReducer } from '../../../slices/allVideosSlice';
  //Miscellaneous.
  import { findChallengesWithEndDate, reduceAllVideosForChallenges, returnChallengeWinner, returnExpiredChallengesOnly, returnVideoLosers, returnVideoWinners, updateDaysRemainingForChallengesWithEndDate, updateVideoLosingRecords, updateWinnerAndTiedVideoRecords } from '../../../functions/miscellaneousFunctions';

import './ActiveChallengesComponent.styles.css';

//Store
import { getAllDocumentsInsideCollection } from '../../../functions/firebase/firestore';

const ActiveChallengesComponent = () => {
  const dispatch = useDispatch();
  const timedChallengesRef = useRef()

  const activeChallenges = useSelector(allActiveChallenges);
  const activeChallengesArray = Object.values(activeChallenges);
  const currentUser = useSelector(loggedInUser);
  const params = useParams();
  const navigate = useNavigate();

  async function stepsForExpiredChallenges() {
    const run_findChallengesWithEndDate = await findChallengesWithEndDate();
    const run_updateDaysRemainingForChallengesWithEndDate = await updateDaysRemainingForChallengesWithEndDate(run_findChallengesWithEndDate);
    const run_returnExpiredChallengesOnly = await returnExpiredChallengesOnly(run_updateDaysRemainingForChallengesWithEndDate);

    timedChallengesRef.current = {
      firebaseExpiredChallenges: run_returnExpiredChallengesOnly,
      firebaseAllVideos: {},
      changedVideos: []
    };

    const getAllVideosInFS = await getAllDocumentsInsideCollection(["internet-idol-faceoff", "Videos", "allVideos"])
      .then(querySnapshot => querySnapshot.forEach(video => timedChallengesRef.current.firebaseAllVideos[video.id] = video.data())).catch(error => console.error({ error, message: "Error inside getAllVideosInFS." }));

    return timedChallengesRef.current;
  }

  useEffect(() => {
    stepsForExpiredChallenges()
      .then(result => {
        let { firebaseExpiredChallenges } = timedChallengesRef.current;

        const updatedExpiredChallenges = firebaseExpiredChallenges.map(expiredChallenge => {
          let { activeChallengeProperties, activeChallengeProperties: { winner }, challengeVideos } = expiredChallenge;

          const run_returnVideoWinners = returnVideoWinners(challengeVideos)
          console.log({ ...timedChallengesRef.current });

          const run_returnChallengeWinner = returnChallengeWinner(run_returnVideoWinners);

          const run_returnVideoLosers = returnVideoLosers(challengeVideos, run_returnVideoWinners);

          const run_updateWinnerAndTiedVideoRecords = updateWinnerAndTiedVideoRecords(run_returnVideoWinners, timedChallengesRef.current);

          const run_updateVideoLosingRecords = updateVideoLosingRecords(run_returnVideoLosers, timedChallengesRef.current)

          const run_reduceAllVideosForChallenges = reduceAllVideosForChallenges(run_updateWinnerAndTiedVideoRecords, run_updateVideoLosingRecords);

          challengeVideos = { ...challengeVideos, ...run_reduceAllVideosForChallenges };
  
          return {
            ...expiredChallenge,
            challengeVideos,
            activeChallengeProperties: {
              ...activeChallengeProperties,
              winner: { ...run_returnChallengeWinner }
            }
          };
        })

        return new Promise((res, rej) => {
          if (!result.changedVideos.length) rej({ ERROR_MESSAGE: "NO VIDEOS TO UPDATE!!!", updatedExpiredChallenges, result });
          else res({ updateFBWithTheseVideos: result.changedVideos, deleteTheseChallenges: updatedExpiredChallenges });
        })
      })
      .then(result => {
        const updateVideosInReduxAndFS = result.updateFBWithTheseVideos.map(video => {
          const payload = {
            _videoID: video._videoID,
            _newKey: "record",
            _newValue: { ...video.record }
          };
          return dispatch(updateFSvideoData({ ...payload }));
        });

        return new Promise((res, rej) => {
          res(result.deleteTheseChallenges);
          rej("Oops... something went wrong with updateVideosInReduxAndFS: ", updateVideosInReduxAndFS)
        })
      })
      .then(result => {
        console.log("Successfully updated both FS and redux!!!");

        result.map(challenge => {
          const { _challengeID, _ownerID, challengeVideos, coverImageDetails: { imageLink, source }, activeChallengeProperties: { title, winner, description } } = challenge;

          const payload = {
            key: _challengeID,
            value: {
              _challengeID,
              _ownerID,
              challengeVideos,
              coverImageDetails: { imageLink, source },
              activeChallengeProperties: { title, winner, description },
            },
            oldType: "activeChallenges",
            newType: "completedChallenges",
            oldCollection: "activeChallenges",
            newCollection: "completedChallenges",
            oldProperty: "allActiveChallenges",
            newProperty: "completedChallenges",
            oldCollectionPathArray: ["internet-idol-faceoff", "Challenges", "activeChallenges", _challengeID],
            newCollectionPathArray: ["internet-idol-faceoff", "Challenges", "completedChallenges", _challengeID]
          }

          return dispatch(FStransferChallenge({ ...payload })); //Uncomment this out when you are ready to dispatch the asyncThunk
        });
      })
      .catch(error => console.error(error))
      .finally(() => {
        timedChallengesRef.current = {
          firebaseExpiredChallenges: [],
          firebaseAllVideos: {},
          changedVideos: []
        };
      })

    return () => {

    }
  }, []);

  if (activeChallengesArray.length === 0) {
    return (
      <div style={{ justifyContent: 'center' }}>
        <h1>There are currently <span className='text-danger'><em>NO</em></span> active challenges.</h1>
      </div>
    )
  }
  else if (params.filterBy === "currentUser") {
    const coverCardContainerVariants = {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1,
        transition: {
          when: 'beforeChildren',
          staggerChildren: 1.25
        }
      }
    }
  
    const coverCardVariants = {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1,
        transition: {
          duration: 0.75
        }
      }
    }

    function handleCoverCardClick(val) {
      const { upcomingChallengeProperties, ...otherProps } = val;

      if (currentUser && currentUser._userID) {
        navigate(`/member/_userID/${val._ownerID}/challenges/details/active/${val._challengeID}`)
      } else {
        navigate(`/challenges/details/active/${val._challengeID}`);
      }   
    }

    const activeChallengesArray = Object.values(activeChallenges)
      .filter(val => val._ownerID == params._userID)
    
    return (
      <>
        <div>
          <strong className='text-danger'>ACTIVE CHALLENGES FOR {params._userID}.</strong>
        </div>
        <motion.div
          variants={coverCardContainerVariants}
          initial="initial"
          animate="animate"
          className='videoGridContainer'
        >
          {
            activeChallengesArray.map(val => (
              <motion.div
                variants={coverCardVariants}
                whileHover={{ border: "7.5px solid lightseagreen", borderRadius: "15px", scale: 1.05 }} className='p-0 m-3'
                onClick={() => handleCoverCardClick(val)}
                key={val._challengeID}
              >
                <ChallengeCoverCard {...val} />
              </motion.div>
            ))
          }
        </motion.div>
      </>
    )
  }
  else {
    const activeChallengesArray = Object.values(activeChallenges).map(val => val);

    const coverCardContainerVariants = {
      initial: {
        opacity: 0
      },
      animate: {
        opacity: 1,
        transition: {
          when: 'beforeChildren',
          staggerChildren: 1.25
        }
      }
    }
  
    const coverCardVariants = {
      initial: {
        opacity: 0,
        scale: 0
      },
      animate: {
        opacity: 1,
        scale: 1,
        transition: {
          duration: 0.75,
          stiffness: 97,
          oscillation: 101,
          type: "spring"
        }
      }
    }

    function handleCoverCardClick(val) {
      const { upcomingChallengeProperties, ...otherProps } = val;

      if (currentUser && currentUser._userID) {
        navigate(`/member/_userID/${val._ownerID}/challenges/details/active/${val._challengeID}`)
      } else {
        navigate(`/challenges/details/active/${val._challengeID}`);
      }      
    }

    return (
      <>
        <div><strong>ALL ACTIVE CHALLENGES:</strong></div>
        <motion.div
          variants={coverCardContainerVariants}
          initial="initial"
          animate="animate"
          className='videoGridContainer'
        >
          {
            activeChallengesArray
              .filter(val => !val.activeChallengeProperties.endActiveChallenge)
              .map(val => (
                <motion.div
                  variants={coverCardVariants}
                  whileHover={{ border: "7.5px solid lightseagreen", borderRadius: "15px", scale: 1.05 }} className='p-0 m-3'
                  onClick={() => handleCoverCardClick(val)}
                  key={val._challengeID}
                >
                  <ChallengeCoverCard {...val} />
                </motion.div>
              ))
          }
        </motion.div>
      </>  
    )
  }
}

export default memo(ActiveChallengesComponent);

  